export class MobileHelper {
  private static mobileDevicesPattern =
    'Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS';

  static isMobile(): boolean {
    const userAgent = window.navigator.userAgent;
    return RegExp(this.mobileDevicesPattern).test(userAgent);
  }
}
